module.exports = __webpack_public_path__ + "img/advertise-modal-image.a2791f7f.png";